// dataSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { tokenVerification } from "../commonFunc/verification";
import GlobalURL from "../baseUrl";

const Language = localStorage.getItem("lang");

const initialState = {
  queryData: [],
  loadingQuery: false,
  errorQuery: null,

  queryStatements: [],
  loadingQueryStatements: false,
  errorQueryStatements: null,
};

export const fetchQueries = createAsyncThunk(
  "data/fetchQueries",
  async (language) => {
    try {
      const token = localStorage.getItem("token");
      const Newtoken = await tokenVerification(token);
      const url = `${GlobalURL}/api/dev/admin/getQueryDetails`;
      const headers = {
        "Content-Type": "application/json",
        lang_id: language,
        token: Newtoken,
        "ngrok-skip-browser-warning": "69420",
      };
      const response = await fetch(url, {
        method: "GET",
        headers: headers,
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error.message);
    }
  }
);

export const fetchQueryStatements = createAsyncThunk(
  "data/fetchQueryStatements",
  async () => {
    try {
      const token = localStorage.getItem("token");
      const Newtoken = await tokenVerification(token);
      const url = `${GlobalURL}/api/dev/admin/getQueryContent`;
      const headers = {
        "Content-Type": "application/json",
        lang_id: Language,
        token: Newtoken,
        "ngrok-skip-browser-warning": "69420",
      };

      const response = await fetch(url, {
        method: "GET",
        headers: headers,
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error("Error:", error.message);
    }
  }
);

const dataSlice = createSlice({
  name: "query",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQueries.pending, (state) => {
        state.loadingQuery = true;
        state.errorQuery = null;
      })
      .addCase(fetchQueries.fulfilled, (state, action) => {
        state.loadingQuery = false;
        state.queryData = action.payload;
      })
      .addCase(fetchQueries.rejected, (state, action) => {
        state.loadingQuery = false;
        state.errorQuery = action.error.message;
      })
      .addCase(fetchQueryStatements.pending, (state) => {
        state.loadingQueryStatements = true;
        state.errorQueryStatements = null;
      })
      .addCase(fetchQueryStatements.fulfilled, (state, action) => {
        state.loadingQueryStatements = false;
        state.queryStatements = action.payload;
      })
      .addCase(fetchQueryStatements.rejected, (state, action) => {
        state.loadingQueryStatements = false;
        state.errorQueryStatements = action.error.message;
      });
  },
});

export default dataSlice.reducer;
